import React from 'react';
import PropTypes from 'prop-types';

export default function Tab({
  label,
  name,
  handleTabChange,
  className,
  isSelected,
  tabIndex,
  id,
  panelId,
  onKeyDown,
  innerRef,
  badgeCount,
}) {
  const showBadge = typeof badgeCount === 'number' && badgeCount > 0;
  const ariaLabel = showBadge ? `${label}, ${badgeCount} incomplete` : undefined;

  return (
    <li role="presentation">
      <button
        ref={innerRef}
        type="button"
        id={id}
        role="tab"
        aria-selected={isSelected}
        {...(panelId ? { 'aria-controls': panelId } : {})}
        {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
        tabIndex={tabIndex}
        className={`tabs__trigger ${className}`.trim()}
        onClick={() => handleTabChange(name)}
        onKeyDown={onKeyDown}
      >
        <span className="tabs__trigger-inner">
          <span className="tabs__trigger-label">{label}</span>
          {showBadge ? (
            <span className="tabs__badge" aria-hidden="true">
              {badgeCount}
            </span>
          ) : null}
        </span>
      </button>
    </li>
  );
}

Tab.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  handleTabChange: PropTypes.func,
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  tabIndex: PropTypes.number,
  id: PropTypes.string,
  panelId: PropTypes.string,
  onKeyDown: PropTypes.func,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  badgeCount: PropTypes.number,
};

Tab.defaultProps = {
  label: '',
  name: '',
  handleTabChange: () => {},
  className: '',
  isSelected: false,
  tabIndex: 0,
  id: '',
  panelId: '',
  onKeyDown: undefined,
  innerRef: undefined,
  badgeCount: undefined,
};
